// extracted by mini-css-extract-plugin
export default {"Integrations-details":"Integrations-details1Ppp3fd-lnJ_","Integrations-details-content":"Integrations-details-content2LDX9qAvp2p5"};